import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const RedirectionIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 29 32"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <g fill={fillColor} fillRule="nonzero">
        <path d="M28.5577638,17.4245362 L24.1275293,13.3742023 C23.7291551,13.0083222 23.1763549,13.0083222 22.7768617,13.3742023 L18.3466272,17.4245362 C17.8564926,17.8758109 17.7602561,18.7223306 18.1340117,19.3136794 C18.5055292,19.9050281 19.2071602,20.0238379 19.6995328,19.5729007 L22.3326073,17.1656523 L22.3326073,25.2703703 C22.3326073,27.4926535 20.8238769,29.2980898 18.9755213,29.2980898 C17.1246479,29.2980898 15.6184353,27.4700391 15.6184353,25.2248041 L15.6184353,6.72895461 C15.6184353,3.01884882 13.1073349,0 10.0232919,0 C6.9392489,0 4.42814857,3.03775038 4.42814857,6.77350829 L4.42814857,14.4353898 L1.79395508,12.0254412 C1.30158247,11.574504 0.599951489,11.6919637 0.227314942,12.2860126 C-0.145321605,12.8773614 -0.0502041677,13.7238811 0.442168447,14.1748183 L4.87128392,18.2251522 C5.07159005,18.4104549 5.30994316,18.5005749 5.54717724,18.5005749 C5.78441132,18.5005749 6.02276442,18.4128176 6.22307055,18.2261647 L10.652186,14.1758309 C11.1456777,13.7248937 11.2419141,12.878374 10.8681586,12.2870252 C10.495522,11.6929763 9.79389104,11.5741665 9.30039939,12.0264537 L6.66620591,14.4337022 L6.66620591,6.77182065 C6.66620591,4.52658559 8.1724185,2.69853492 10.0232919,2.69853492 C11.8741653,2.69853492 13.3803779,4.50768403 13.3803779,6.72726697 L13.3803779,25.2264917 C13.3803779,28.9622496 15.8903592,32 18.9755213,32 C22.0592845,32 24.5706646,28.9811512 24.5706646,25.2707079 L24.5706646,17.168015 L27.2048581,19.5752634 C27.4096404,19.7605662 27.6457554,19.8496735 27.8807514,19.8496735 C28.2209361,19.8496735 28.5555257,19.6630207 28.7745756,19.3150295 C29.1452538,18.7219931 29.0490174,17.8758109 28.5577638,17.4245362 Z" />
      </g>
    </g>
  </svg>
);

RedirectionIcon.defaultProps = defaultProps;

export default RedirectionIcon;
